import React from 'react';
import AgregarPromociones from './AgregarPromociones';

function NuevaPromocion() {
    return <AgregarPromociones />;
}

export default NuevaPromocion;
